import moment from 'moment'
// import Vue from 'vue'

export default {
  data () {
    return {
      calendars: {},
      ignoredStatuses: ['c']
    }
  },
  // watch: {
  //   practitioner () {
  //     this.getPractitionerCalendar()
  //   }
  // },
  methods: {
    getPractitionerCalendar () {
      let practitionerId = this.getObjectPath(this, 'practitioner.id', this.meId)
      let fromDate = this.$store.state.application.activeDateRange.from
      let toDate = this.$store.state.application.activeDateRange.to
      this.getPractitionerAppointments(practitionerId, fromDate, toDate)
    },
    formatEvents (events) {
      let facets = {
        spaces: {},
        products: {}
      }
      if (!events) { return [] }
      let formatted = events.map((evt) => {
        evt['start'] = moment(evt.start_time).format('HH:mm')
        evt['end'] = moment(evt.end_time).format('HH:mm')
        evt['highlight'] = false
        if (evt.space) {
          facets.spaces[evt.space] = {
            title: evt.service_name
          }
          if (parseInt(this.selectedSpace) === parseInt(evt.space)) {
            evt['highlight'] = true
          }
          facets.products[evt.product] = {
            title: evt.product_name
          }
        }
        if (this.facets && facets) {
          this.facets = facets
        }
        return evt
      })
      return formatted.filter((evt) => {
        return this.ignoredStatuses.indexOf(evt.status.toLowerCase()) === -1
      })
    }
  },
  computed: {
    myEvents () {
      return this.$store.getters.appointments
    },
    events () {
      let events = []
      if (this.practitioner && this.practitioner.id !== this.me.id) {
        let path = `${this.practitioner.id}.result.results`
        events = this.getObjectPath(this.calendars, path, [])
      } else {
        events = this.myEvents
      }
      return this.formatEvents(events)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/CalendarMixins.js